export enum AppointmentPurpose {
  AtendimentoPresencial = 1,
  PeriodoGarantido = 2,
  HorariosMenores = 3,
  HorariosEstendidos = 4,
}
